import { WellnessWheelIconProps } from "../types";

export default function InfoCategoryIcon({
  iconColorFill,
  arcColorFill,
}: WellnessWheelIconProps) {
  return (
    <g
      style={{
        animation: "scaleIn 0.2s ease-out 2.50s forwards",
        transformOrigin: `137.225px 28.028px`,
        opacity: 0,
      }}
    >
      {/* Top-right cutout for Info icon */}
      <path
        d="M137.232 56.0602C140.993 56.0602 144.716 55.303 148.179 53.8337C151.642 52.3645 154.774 50.2132 157.388 47.5081C160.001 44.8029 162.044 41.5993 163.394 38.0882C164.743 34.577 165.372 30.83 165.243 27.0706C165.114 23.3112 164.23 19.6162 162.643 16.2058C161.055 12.7954 158.798 9.73941 156.005 7.21988C153.212 4.70035 149.94 2.76885 146.384 1.54046C142.829 0.312079 139.063 -0.188053 135.31 0.0698664L137.232 28.0321L137.232 56.0602Z"
        fill={"white"}
        stroke="white"
        strokeWidth="3"
      />

      {/* Info icon circle - Top right */}
      <rect
        x="113.656"
        y="3.45886"
        width="47.1383"
        height="47.1383"
        rx="23.5691"
        fill={iconColorFill}
      />
      <rect
        x="113.656"
        y="3.45886"
        width="47.1383"
        height="47.1383"
        rx="23.5691"
        stroke={arcColorFill}
        strokeWidth="3.82202"
      />

      {/* Info icon - head shape */}
      <path
        d="M150.12 28.2583C149.415 34.0388 145.051 38.6915 138.277 38.6915C132.215 38.6915 125.87 35.0326 125.87 28.2583C125.87 15.7103 132.772 14.4414 139.546 14.4414C146.32 14.4414 150.12 21.484 150.12 28.2583Z"
        fill="white"
      />
      <path
        d="M139.541 19.7109C139.541 21.2702 139.037 21.0732 138.104 21.0732C136.375 21.0733 136.2 21.2705 136.2 19.5518C136.2 18.7005 136.416 18.4365 138.104 18.4365C138.9 18.5251 139.541 18.2229 139.541 19.7109ZM138.755 33.6689C138.033 33.7375 136.361 33.9634 136.361 33.1338C136.361 31.8429 136.311 28.9686 136.361 28.3516C136.412 27.7349 136.298 25.0945 136.449 23.9023C136.416 23.7379 136.51 23.4173 137.154 23.4502C137.799 23.4831 138.358 23.3829 138.915 23.4502C139.47 23.5175 139.402 24.0856 139.401 24.1436C139.402 24.5976 139.323 26.1894 139.323 26.6006C139.323 27.0117 139.561 32.311 139.208 33.1338C139.158 33.3067 139.123 33.6689 138.755 33.6689Z"
        fill={iconColorFill}
      />
    </g>
  );
}
